import * as types from '../mutation-types'

// initial state
const state = {
  flag: false
};
// getters
const getters = {};

// actions
const actions = {
  updateLoadingStatus: function (context, flag) {
    context.commit(types.UPDATE_LOADING, flag);
  }
};

// mutations
const mutations = {
  [types.UPDATE_LOADING](state, flag) {
    state.flag = flag;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/loading.js